import React from 'react'

const AppPagesHeading = (props) => {
  return (

    <div>
   
    <h1 className="container text_left"
      style={{
        fontSize: "25px",
        fontWeight: "700",
        margin: "0px",
        padding: "0px",
        whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "238px"
       
      }}
    >
      {props.heading}

      
      
    </h1>


      {props.componentFrom && (
        <>
          <span className="last_updated_text blog_back_heading">
          🎧 Listen to Blogs for Free

          </span>
        </>
      )}
  </div>

    
  
  )
}

export default AppPagesHeading